import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEThiemeTargetType = {
    anatomy:        'anatomy',
    biology:        'biology',
    head:           'head'
};

OEThiemeTargetType.all = [
    OEThiemeTargetType.anatomy,
    OEThiemeTargetType.biology,
    OEThiemeTargetType.head
];

export const OEThiemeStartSelectionContent = {
    [OEThiemeTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
// @ADD_TARGET_THIEME_TARGETMENU
                        OETargetMenuDefs.thiemeArm,
                        OETargetMenuDefs.thiemeShoulderGirdle,
                        OETargetMenuDefs.thiemeShoulderGirdleAnimation,
                        OETargetMenuDefs.thiemeUpperArmElbow,
                        OETargetMenuDefs.thiemeForearm,
                        OETargetMenuDefs.thiemeHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.thiemeLeg,
                        OETargetMenuDefs.thiemeHip2,
                        OETargetMenuDefs.thiemeThighKnee,
                        OETargetMenuDefs.thiemeLowerLeg,
                        OETargetMenuDefs.thiemeAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.thiemeTrunk,
                        OETargetMenuDefs.thiemeNeckBack,
                        OETargetMenuDefs.thiemeChestWall,
                        OETargetMenuDefs.thiemeAbdominalWall,
                        OETargetMenuDefs.thiemePelvis,
                        OETargetMenuDefs.thiemeSpine
                    ]
                }
            ]
        }
    ],
    [OEThiemeTargetType.head]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.thiemeSkull,
                        OETargetMenuDefs.thiemeHead,
                        OETargetMenuDefs.thiemeCNS,
                        OETargetMenuDefs.thiemeCranialNerves,
                        OETargetMenuDefs.thiemeEye2,
                        OETargetMenuDefs.thiemeEyeAnimation,
                        OETargetMenuDefs.thiemeEyeRetina,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.thiemeEarMacro,
                        OETargetMenuDefs.thiemeEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.thiemeLarynx,
                        OETargetMenuDefs.thiemeLarynxAnimation,
                    ]
                }
            ]
        }
    ],
    [OEThiemeTargetType.biology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.virusSarscov2,
                    ]
                }
            ]
        }
    ],

    [OEThiemeTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.thiemeArm,
                        OETargetMenuDefs.thiemeShoulderGirdle,
                        OETargetMenuDefs.thiemeUpperArmElbow,
                        OETargetMenuDefs.thiemeForearm,
                        OETargetMenuDefs.thiemeHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.thiemeLeg,
                        OETargetMenuDefs.thiemeHip2,
                        OETargetMenuDefs.thiemeThighKnee,
                        OETargetMenuDefs.thiemeLowerLeg,
                        OETargetMenuDefs.thiemeAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.thiemeTrunk,
                        OETargetMenuDefs.thiemeNeckBack,
                        OETargetMenuDefs.thiemeChestWall,
                        OETargetMenuDefs.thiemeAbdominalWall,
                        OETargetMenuDefs.thiemePelvis,
                        OETargetMenuDefs.thiemeSpine
                    ]
                }
            ]
        }
    ],
    [OEThiemeTargetType.head + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.thiemeSkull,
                        OETargetMenuDefs.thiemeCNS,
                        OETargetMenuDefs.thiemeHead,
                        OETargetMenuDefs.thiemeCranialNerves,
                        OETargetMenuDefs.thiemeEye2,
                        OETargetMenuDefs.thiemeEyeAnimation,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.thiemeEarMacro,
                        OETargetMenuDefs.thiemeEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.thiemeLarynx,
                        OETargetMenuDefs.thiemeLarynxAnimation,
                    ]
                }
            ]
        }
    ],
    [OEThiemeTargetType.biology + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.virusSarscov2,
                    ]
                }
            ]
        }
    ],

    [OEThiemeTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.thiemeArm,
                        OETargetMenuDefs.thiemeShoulderGirdle,
                        OETargetMenuDefs.thiemeUpperArmElbow,
                        OETargetMenuDefs.thiemeForearm,
                        OETargetMenuDefs.thiemeHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.thiemeLeg,
                        OETargetMenuDefs.thiemeHip2,
                        OETargetMenuDefs.thiemeThighKnee,
                        OETargetMenuDefs.thiemeLowerLeg,
                        OETargetMenuDefs.thiemeAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.thiemeTrunk,
                        OETargetMenuDefs.thiemeNeckBack,
                        OETargetMenuDefs.thiemeChestWall,
                        OETargetMenuDefs.thiemeAbdominalWall,
                        OETargetMenuDefs.thiemePelvis,
                        OETargetMenuDefs.thiemeSpine
                    ]
                }
            ]
        }
    ],
    [OEThiemeTargetType.head + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.thiemeSkull,
                        OETargetMenuDefs.thiemeCNS,
                        OETargetMenuDefs.thiemeHead,
                        OETargetMenuDefs.thiemeCranialNerves,
                        OETargetMenuDefs.thiemeEye2,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.thiemeEarMacro,
                        OETargetMenuDefs.thiemeLarynx,
                    ]
                }
            ]
        }
    ],
    [OEThiemeTargetType.biology + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.virusSarscov2,
                    ]
                }
            ]
        }
    ],
};

OEThiemeStartSelectionContent.modules = [
    {id: OEThiemeTargetType.anatomy, icon: OEIconCodes.thieme.anatomyTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.anatomy]},
    {id: OEThiemeTargetType.biology, icon: OEIconCodes.thieme.biologyTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.biology]},
    {id: OEThiemeTargetType.head, icon: OEIconCodes.thieme.headTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.head]}
];

OEThiemeStartSelectionContent.modulesBeta = [
    {id: OEThiemeTargetType.anatomy, icon: OEIconCodes.thieme.anatomyTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
    {id: OEThiemeTargetType.biology, icon: OEIconCodes.thieme.biologyTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.biology + OEAlphaBetaProdTypes.beta]},
    {id: OEThiemeTargetType.head, icon: OEIconCodes.thieme.headTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.head + OEAlphaBetaProdTypes.beta]}
];

OEThiemeStartSelectionContent.modulesProduction = [
    {id: OEThiemeTargetType.anatomy, icon: OEIconCodes.thieme.anatomyTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
    {id: OEThiemeTargetType.head, icon: OEIconCodes.thieme.headTarget, categories: OEThiemeStartSelectionContent[OEThiemeTargetType.head + OEAlphaBetaProdTypes.prod]}
];